<template>
  <div class="pages">
    <div class="top facab">
      <div class="t-l">{{ $t('main.productInquiry') }}</div>
      <div class="t-r">
        <el-input :placeholder="$t('main.search')" v-model="input3" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <div class="content">
      <div class="t-th fac">
        <div class="tl-th1">
          <el-checkbox v-model="checked" @change="selectAll">{{ $t('main.SelectAll') }}</el-checkbox>
        </div>
        <div class="tl-th2">{{ $t('main.ProductSpecifications') }}</div>
        <div class="tl-th3">{{ $t('main.totalNum') }}</div>
        <div class="tl-th3">{{ $t('main.Manage') }}</div>
      </div>
      <div>
        <div v-if="hasItem" style="color: rgb(153, 153, 153);">
          <div class="t-td fac"  v-for="(item, index) in inquiryList" :key="index">
            <div class="tl-th1">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </div>
            <div class="tl-th2 fac" style="padding:1rem 0;">
              <img style="cursor: pointer;" @click="gotoProductDetail(item)" :src="item.productimg" class="tr-img" />
              <div class="td-label">
                <div class="fac lh30" style="color: #333333;">
                  <div style="width: 10rem;">{{ $t('main.product') }}</div>
                  <div style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.type_name}}</div>
                </div>
                <div class="fac lh30" style="color: #333333;">
                  <div style="width: 10rem;">{{ $t('main.partNumber') }}</div>
                  <div style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.product_model}}</div>
                </div>
                <div class="fac lh30" v-for="(itemd, ind) in item.product_info" v-if="itemd.isShow" :key="ind">
                  <div style="width: 10rem">{{ itemd.title }}</div>
                  <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                </div>
                <div class="fac lh30" v-for="(itemd, inds) in item.product_info" v-if="!itemd.isShow && showMore.findIndex(res=>{return res == item.id;}) > -1" :key="inds">
                  <div style="width: 10rem">{{ itemd.title }}</div>
                  <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                </div>
                <div class="fac color-635796" style="cursor: pointer;" @click="handleProductParamsMore(item)">
                  {{ showMore.findIndex(res=>{return res == item.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                  <i :class="showMore.findIndex(res=>{return res == item.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                </div>
              </div>
            </div>
            <div class="tl-th3">
              <el-input-number
                :label="$t('main.shopCarNum')"
                :min="1"
                v-model="item.number"
                @change="updateQuantity(item)"
              ></el-input-number>
              <div style="color: #999; padding-top: 0.75rem">{{ $t('main.StockNum') }}:{{ item.kucun }}</div>
            </div>
            <div class="tl-th3" @click="handleDelete(item.id)" style="cursor:pointer">{{ $t('main.delete') }}</div>
          </div>
        </div>
      </div>
      <div v-if="!inquiryList.length" class="no-data">{{ $t('main.noData') }}</div>
      <div class="t-bottom facab">
        <div style="padding-left: 1rem">
          <el-checkbox v-model="checked" @change="selectAll">{{ $t('main.SelectAll') }}</el-checkbox>
          <span class="blt" style="padding-left: 1rem;cursor:pointer" @click="handleSelectedDelete(1)"
            >{{ $t('main.DeleteSelected') }}</span
          >
          <span class="blt" style="padding-left: 1rem;cursor:pointer" @click="handleSelectedDelete(0)">{{ $t('main.clearInquiryCart') }}</span>
        </div>
        <div>
          <span
              style="margin-right: 4.25rem"
              v-html="$t('main.chooseShopNum', { num: shoppingnum })">
          </span>
        </div>
        <div class="t-bottom facab">
          <div></div>
          <div>
            <el-button class="mainBtm" @click="goToSubmit()">
              {{ $t("main.commit") }}
            </el-button>
          </div>
        </div>
      </div>

      <el-row>
        <el-col>
          <el-dialog :title="$t('main.ConsigneeInformation')" :visible.sync="addressDialogVisible" width="40%" :before-close="handleClose">
            <el-form ref="form" :model="addressData" label-width="150px">
              <el-form-item class="is-required" :label="$t('main.receiver')">
                <el-input v-model="addressData.receive_user" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.telephone')">
                <el-input v-model="addressData.receive_phone" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :class="!isCN ? 'is-required': ''" :label="$t('main.email')">
                <el-input v-model="addressData.receive_email" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.orderCompany')">
                <el-input v-model="addressData.receive_company" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item v-if="isCN" :label="$t('main.addressDetail')">
                <el-input v-model="addressData.receive_address" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item v-if="!isCN" :label="$t('main.AddressLine1')">
                <el-input v-model="addressData.receive_address" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item v-if="!isCN" :label="$t('main.AddressLine2')">
                <el-input v-model="addressData.receive_address_2" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item v-if="!isCN" :label="$t('main.AddressLine3')">
                <el-input v-model="addressData.receive_address_3" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" @click="submitAddressData">{{ $t('main.sure') }}</el-button>
                <el-button class="btn-close" @click="handleClose">{{ $t('main.cancel') }}</el-button>
              </span>
          </el-dialog>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Inquirylist, editInquiry, delInquiry, placeInquiry } from "@/api/inquiry";
import { getProductInfo } from '@/api/index'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      isCN: this.$i18n.locale === "zn", // 判断当前是中文还是英文
      itemId: 1, // to be changed
      input3: '',
      showMore: [],
      value: '',
      checked: true,
      num: 1,
      // 咨询产品list
      inquiryList: [],
      // 咨询提交 产品list
      paramsToInquiry: [],

      addressDialogVisible:false,
      addressOperateFlag:false,
      // 遮罩层
      loading: false,
      addressData: {
        receive_user:'',
        receive_phone:'',
        receive_email:'',
        receive_company:'',
        receive_address:'',
        receive_address_2:'',
        receive_address_3:'',
      },
      address:{
        page: 1,
        limit: 5,
        total: 1,
      },

      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  methods: {
    //初始化数据
    initData() {
      //请求数据
      let params = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ],
          order: "id desc"
        }
      }
      this.getInquirylist(params);
      //模拟数据
      // console.log('所有商品信息', this.inquiryList)
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    getInquirylist(params) {
      Inquirylist(params)
        .then(res => {
          if (res.data.list.length !== 0) {
            this.inquiryList = []
            const productType = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
            for (let i = 0; i < res.data.list.length; i++) {
              const nowProductType = productType.find(productType => {
                return productType.id == res.data.list[i].product_info.type_id;
              });

              // 设置默认选中
              const singleData = {
                uuid: res.data.list[i].uuid,
                user_id: res.data.list[i].user_id,
                type_id: res.data.list[i].product_info.type_id,
                type_name: nowProductType.name,
                product_id: res.data.list[i].product_id,
                product_info: res.data.list[i].product_info.product_data,
                price: res.data.list[i].price,
                number: res.data.list[i].number,
                site_id: '',
                productimg: res.data.list[i].product_info.thumb,
                kucun: res.data.list[i].product_info.stock,
                id: res.data.list[i].id,
                checked: true,// 购物车是否选中
                product_model: res.data.list[i].product_info.product_model
                //缺少字段：1，产品图片
              };
              this.inquiryList.push(singleData)
            }
          } else {
            this.inquiryList = []
          }
        })
        .catch(err => {
          this.inquiryList = []
        })
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    goToSubmit() {
      //组装paramsToInquiry
      //获取选定的商品信息
      let checkInquiry = [];
      for (var i = 0; i < this.inquiryList.length; i++) {
        if (this.inquiryList[i].checked == true) {
          checkInquiry.push(this.inquiryList[i]);
        }
      }
      this.paramsToInquiry.inquiryInfo = checkInquiry;

      //判断是否选择商品
      if (this.paramsToInquiry.inquiryInfo.length == 0) {
        this.$message({
          message: this.$t('main.pleaseSelectProduct'),
          type: 'error'
        })
        return
      } else {
        this.addressDialogVisible = true;
        this.addressOperateFlag = true;
        return
      }
    },
    updateQuantity(current) {
      // console.log(current.id)
      // todo
      // shoppingCarCountChange().then(res => {
      //
      // })
      this.inquiryList.forEach(item => {
        if (current.id == item.id) {
          item.number = current.number;
          editInquiry(item.id, current.number);
        }
      });
    },

    selectAll() {
      //设置所有的check状态为true
      for (var j = 0; j < this.inquiryList.length; j++) {
        if (this.checked == true) {
          this.inquiryList[j].checked = true
        } else {
          this.inquiryList[j].checked = false
        }
      }
    },
    search() {
      let params = {
        req: {
          where: [
            {
              filed: 'product_info',
              expression: 'LIKE',
              condition: `%${this.input3}%`
            },
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ]
        }
      };
      this.getInquirylist(params)
    },
    handleDelete(item) {
      if (item && item.length !== 0) {
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        }).then(() => {
          delInquiry(item.toString()).then(res => {
            if (res.rsp.code == 0) {
              this.$message({
                message: this.$t('main.operationCompletedSuccessfully'),
                type: 'success'
              })
              var params = {
                req: {
                  where: [
                    {
                      filed: 'product_info',
                      expression: 'LIKE',
                      condition: `%${this.input3}%`
                    },
                    {
                      "condition": Cookies.get("siteInfo"),
                      "filed": "site_id",
                      "expression": "="
                    }
                  ]
                }
              }
              this.checked = false
              this.getInquirylist(params);
              this.$store.dispatch("setInquiryNum", true);
            } else {
              this.$message({
                message: res.rsp.msg,
                type: 'error'
              })
            }
          })
        }).catch(() => {
          // 用户取消删除
        });
      } else {
        this.$message({
          message: this.$t('main.pleaseSelectProduct'),
          type: 'error'
        })
      }
    },
    handleSelectedDelete(type) {
      var choosedArr = []
      for (var i = 0; i < this.inquiryList.length; i++) {
        if (type) {
          if (this.inquiryList[i].checked) {
            choosedArr.push(this.inquiryList[i].id)
          }
        } else {
          choosedArr.push(this.inquiryList[i].id)
        }
      }
      this.handleDelete(choosedArr);
    },
    handleCheckboxChange(item) {
      // console.log(item);
    },
    handleClose() {
      this.addressDialogVisible = false;
      this.billingDialogVisible = false;
    },
    //添加和修改
    submitAddressData() {
      // TODO 组装数据
      if (!this.addressData.receive_user) {
        // 联系人 必填
        this.$message({
          message: this.$t('main.fieldIsRequired', {field: this.$t('main.receiver')}),
          type: 'error'
        })
        return
      }
      if (!this.isCN && !this.addressData.receive_email) {
        // 邮箱 必填
        this.$message({
          message: this.$t('main.fieldIsRequired', {field: this.$t('main.email')}),
          type: 'error'
        })
        return
      }
      if (this.addressData.receive_email) {
        // 验证邮箱格式
        const emailPattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*.[a-zA-Z0-9]{2,6}$/;
        if (!emailPattern.test(this.addressData.receive_email)) {
          this.$message({
            message: this.$t('main.fieldIsError', {field: this.$t('main.email')}),
            type: 'error'
          })
          return
        }
      }
      if (this.isCN && !this.addressData.receive_phone) {
        // 中文 电话 必填
        this.$message({
          message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
          type: 'error'
        })
        return
      }

      //组装提交数据
      var productidAndNumArr = []
      for (let i = 0; i < this.paramsToInquiry.inquiryInfo.length; i++) {
        var singlProductandnum = {}
        singlProductandnum.product_id = this.paramsToInquiry.inquiryInfo[i].product_id
        singlProductandnum.number = this.paramsToInquiry.inquiryInfo[i].number
        productidAndNumArr.push(singlProductandnum)
      }
      const orderParams = {
        req: {
          product_id_numbers: productidAndNumArr,
          address_id: 0,
          address_info:this.addressData
        }
      };
      placeInquiry(orderParams).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch('setInquiryNum', true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success",
          });
          this.$router.push("/");
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
      return;
    }
  },
  created() {
    if ((this.$store.state.userInfo && this.$store.state.userInfo.username) || Cookies.get("userinfo")) {
      this.isLogin = true;
      const userInfo = JSON.parse(Cookies.get("userinfo")) || this.$store.state.userInfo;
      if(this.$i18n.locale === 'zn') {
        this.addressData.receive_user = userInfo.nickname;
        this.addressData.receive_phone = userInfo.telephone;
        this.addressData.receive_email = userInfo.email;
      } else {
        this.addressData.receive_user = userInfo.nickname;
        this.addressData.receive_phone = userInfo.telephone;
        this.addressData.receive_email = userInfo.email;
      }
    }
    this.initData();
  },
  computed: {
    shoppingnum() {
      let num = 0
      this.inquiryList.forEach(item => {
        if (item.checked) {
          num += item.number
        }
      })
      return num
    },
    hasItem() {
      return this.num != 0
    }
  },
  watch: {
    "$store.state.siteInfo": function(newV, oldV) {
      this.isCN = this.$i18n.locale === "zn";
      if (newV && typeof oldV != 'object') {
        this.$router.push({ path: "/inquiry"});
      }
      this.initData();
    },
    num(value) {
      // 修改购物车的数量和总金额
      editInquiry(this.itemId, value).then(res => {
        // console.log(res)
      })
    }
  }
  //TOOD 监听对象里面的内容
}
</script>

<style lang="less" scoped>
.pages {
  min-height: 100%;
  background-color: #fff;
  .top {
    .t-l {
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #635796;
      line-height: 2.25rem;
    }
    .t-c {
      height: 2.5rem;
      border: 1px solid #cccccc;
      border-radius: 4px;
      ::v-deep .el-input-group__append,
      .el-input-group__prepend {
        background-color: #fff;
        border: 0;
        padding: 0 10px;
      }
      ::v-deep .el-input__inner {
        height: 2.375rem;
        line-height: 2.375rem;
        border: 0;
      }
    }
  }
  .content {
    .t-th {
      width: 100%;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      height: 3.75rem;
      line-height: 3.75rem;
    }
    .t-td {
      padding: 1rem 0;
      border: 1px solid #f5f5f5;
      .tl-th3 {
        .el-input-number{
          max-width: 130px;
        }
      }
      .tr-img {
        height: 4.8rem;
        margin-right: 1.5rem;
      }
      .td-label {
        text-align: left;
      }
    }
    .t-td:nth-child(even) {
      background: #f2f2f2;
    }

    .no-data {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .t-bottom {
      margin-top: 0.5rem;
      height: 3.75rem;
      line-height: 3.75rem;
      border: 1px solid #e6e6e6;
      .blt {
        padding-left: 1rem;
        color: #666666;
      }
      .mainBtm {
        width: 10rem;
        height: 3.75rem;
        background: #635796;
        color: #ffffff;
      }
    }
    .t-td + .t-td {
      margin-top: 0.5rem;
    }
    .tl-th1 {
      width: 5rem;
      padding-left: 1rem;
    }
    .tl-th2 {
      width: calc(50% - 5rem);
      text-align: center;
    }
    .tl-th3 {
      width: 25%;
      text-align: center;
    }
    .tl-th {
      width: 10%;
      text-align: center;
    }
    .lh30 {
      line-height: 1.5rem;
    }

    .c-th {
      height: 3.75rem;
      line-height: 3.75rem;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      padding: 0 0.625rem;
      margin-top: 2.5rem;
    }
    .addr-serach {
      padding: 1.5rem 4.5rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .addr-list {
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;

      .el-radio-group {
        width: 100%;

        .el-radio {
          word-wrap: break-word;
          word-break: normal;
          white-space: normal;
        }
      }
    }

    .el-radio {
      display: block;
      padding: 0.5rem 4.5rem;
    }

    .el-pagination {
      padding: 1.5rem 4.5rem;
      text-align: center;
    }
  }

  .add-address {
    height: 80px;
    line-height: 80px;
    text-align: center;

    &:hover {
      cursor: pointer;
    }
  }

  /deep/ .el-select .el-input .el-select__caret {
    font-size: 1rem;
    height: 2.375rem;
    line-height: 2.375rem;
  }
  /deep/ .el-input-number__decrease,
  /deep/ .el-input-number__increase {
    bottom: 1px;
  }
  @media screen and (max-width: 1400px) {
    .top {
      padding: 3.25rem 2% 1.5rem;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .top {
      padding: 3.25rem 10% 1.5rem;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .top {
      padding: 3.25rem 15% 1.5rem;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }
}

.btn {
  background: #635796;
  border-radius: 4px;
  border-color: #635796;
  color: #ffffff;
}
.btn-close {
  background: #FFF;
  border-radius: 4px;
  border-color: #DCDFE6;
  color: #606266;
}
</style>
